import React from "react";
import { projects } from "@/lib/data";
import { SectionHeader } from "@/components/About";
import { ArrowUpRight } from "lucide-react";

export default function Projects() {
    return (
        <section
            id="projects"
            data-testid="projects-section"
            className="relative py-24 md:py-32 border-t border-term-green/15"
        >
            <SectionHeader
                index="04"
                label="projects"
                command="ls ./projects/"
            />

            <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-12">
                <div
                    data-testid="projects-grid"
                    className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-term-green/15 border border-term-green/20"
                >
                    {projects.map((p, i) => (
                        <ProjectCard key={p.name} project={p} index={i} />
                    ))}
                </div>

                <p className="mt-6 font-mono text-xs text-ink-tertiary">
                    <span className="text-term-green">$</span> view more on{" "}
                    <a
                        href="https://www.manojsuthar.com/"
                        target="_blank"
                        rel="noreferrer"
                        data-testid="projects-more-link"
                        className="text-term-green hover:underline underline-offset-4"
                    >
                        manojsuthar.com
                    </a>
                </p>
            </div>
        </section>
    );
}

function ProjectCard({ project, index }) {
    return (
        <a
            href={project.url}
            target="_blank"
            rel="noreferrer"
            data-testid={`project-card-${index}`}
            className="group relative bg-bg-base p-7 md:p-8 min-h-[220px] flex flex-col justify-between hover:bg-bg-surface transition-colors glow-on-hover"
        >
            <div className="flex items-start justify-between">
                <span className="font-mono text-[10.5px] uppercase tracking-[0.24em] text-term-green">
                    // 0{index + 1} / project
                </span>
                <ArrowUpRight className="w-4 h-4 text-ink-tertiary group-hover:text-term-green group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
            </div>

            <div className="space-y-2">
                <h4 className="font-mono text-2xl md:text-3xl font-bold text-ink-primary tracking-tight group-hover:text-term-green transition-colors">
                    {project.name}
                </h4>
                <div className="font-mono text-[11px] text-ink-tertiary truncate">
                    {project.url.replace(/^https?:\/\//, "").replace(/\/$/, "")}
                </div>
                <p className="font-display text-sm text-ink-secondary pt-2 leading-relaxed">
                    {project.description}
                </p>
            </div>

            <span className="absolute top-3 right-3 w-2 h-2 border-t border-r border-term-green/0 group-hover:border-term-green/80 transition-colors" />
            <span className="absolute bottom-3 left-3 w-2 h-2 border-b border-l border-term-green/0 group-hover:border-term-green/80 transition-colors" />
        </a>
    );
}
